<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="reportTitle" v-if="reportTitle" />
    </template>

    <div class="grid-report">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :allow-column-reordering="true"
            :reshape-on-push="true"
            :columns="columns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight"
            v-if="loadingCompleted && jsonData"
            @content-ready="listContentReady"
            ref="grid-report-grid"
          >
            <DxExport :enabled="true" :file-name="saveFileName" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="false" />

            <DxSummary v-if="columnSummary">
              <DxGroupItem
                v-for="item in columnSummary"
                :key="item['id']"
                :column="item['column']"
                :summary-type="item['summary-type']"
                :value-format="item['value-format']"
                :display-format="item['display-format']"
                :show-in-group-footer="item['show-in-group-footer']"
                :align-by-column="item['align-by-column']"
                :show-in-column="item['show-in-column']"
              />
            </DxSummary>

            <template #customer-group-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerGroupDescription"
                :code="data.data.CustomerGroupCode"
              />
            </template>

            <template #customer-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerTypeDescription"
                :code="data.data.CustomerTypeCode"
              />
            </template>

            <template #customer-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerName"
                :code="data.data.CustomerCode"
              />
            </template>

            <template #branch-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.BranchDescription"
                :code="data.data.BranchCode"
              />
            </template>

            <template #category-1-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory1Description"
                :code="data.data.ProductCategory1Code"
              />
            </template>

            <template #category-2-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory2Description"
                :code="data.data.ProductCategory2Code"
              />
            </template>

            <template #category-3-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory3Description"
                :code="data.data.ProductCategory3Code"
              />
            </template>

            <template #category-4-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory4Description"
                :code="data.data.ProductCategory4Code"
              />
            </template>

            <template #sales-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.SalesRepresentativeFullName"
                :code="data.data.SalesRepresentativeCode"
              />
            </template>
            <template #item-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ItemDescription1"
                :code="data.data.ItemCode"
              />
            </template>
          </dx-data-grid>
        </template>

        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :filterFormHeight="filterFormHeight"
            :advanceFilterArray="advanceFilterArray"
            :filterCallBack="applyFilter"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="jSonDataItems"
            :dirty.sync="filterDirty"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { GridReportService } from "../../_services/api/reports/grid-report.service";
import {
  DxSummary,
  DxGroupItem,
  DxExport,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: { DxExport, DxGrouping, DxSummary, DxGroupItem, DxGroupPanel },
  data() {
    return {
      advanceFilterArray: [],
      jsonData: undefined,
      jSonDataItems: undefined,
      reportTitle: undefined,
      dataSourceConfig: [],
      showLeftContainer: true,
      showRightContainer: false,
      filterDirty: { isDirty: false },
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            item.classList.remove("dx-state-invisible");
          },
        },
      },
      filterFormHeight: "auto",
      sideBarTabs: [
        {
          id: 0,
          text: "Filters",
        },
      ],
      saveFileName: undefined,
      filterByDate: false,
      apiRouteUrl: undefined,
      loaded: false,
      columnSummary: undefined,
    };
  },
  created() {
    this.showLoading(true);

    import("./" + this.baseView.query.file + ".json")
      .then((json) => {
        // this.$logger.debug("json data ", json);
        this.jsonData = json;
        this.reportTitle = this.jsonData.title;
        this.saveFileName = this.jsonData["report-file-name"];
        this.apiRouteUrl = this.jsonData["api-route"];
        this.jSonDataItems = this.jsonData["filter-parameters"];
        this.columnSummary = this.jsonData["column-summary"];

        this.getReportData(undefined, []);
      })
      .catch((error) => {
        if (error) {
          this.loadingCompleted = true;
          this.$router.push({
            name: "pageNotFound",
          });
        }
      });
  },
  methods: {
    async getReportData(DateGroup, filterCollection) {
      let ds = GridReportService.dataSourceConfig(this.apiRouteUrl["url"], {
        count: true,
        preventPagination: true,
        filter: this.apiRouteUrl["filter"]
          ? this.apiRouteUrl["filter"]
          : undefined,
      });
      if (DateGroup != undefined) {
        ds.filter(`DateGroup eq ${DateGroup}`);
      }
      await ds.load();

      this.dataSourceConfig = ds.items();
      if (filterCollection.length != 0) {
        let grid = this.$refs["grid-report-grid"].instance;
        if (filterCollection.length > 0) {
          grid.filter(filterCollection);
          grid.refresh(true);
        }
      }
      this.showLoading(false);
      this.loadingCompleted = true;
    },
    listContentReady(e) {
      this.filterFormHeight =
        document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
          .clientHeight -
        document.getElementsByClassName("dx-datagrid-header-panel")[0]
          .clientHeight -
        30;

      this.addGridNoResults(e);
    },
    applyFilter(filterCollection, filterField, e) {
      if (filterField == "DateGroup") {
        this.filterByDate = true;
        this.showLoading(true);
        this.getReportData(e.value, filterCollection);
      } else {
        let grid = this.$refs["grid-report-grid"].instance;
        if (filterCollection.length > 0) {
          grid.filter(filterCollection);
          grid.refresh(true);
        } else {
          this.advanceFilterArray = [];
          grid.clearFilter();
          if (filterField == undefined && this.filterByDate) {
            this.advanceFilterArray = [];
            this.filterByDate = false;
            this.showLoading(true);
            this.getReportData(undefined, []);
          }
        }
      }
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    backButtonFunction() {
      this.$router.push({
        path: "/reports/sales",
      });
    },
  },
  computed: {
    columns() {
      var columnArray = JSON.parse(JSON.stringify(this.jsonData.columns));

      return this.parseGridColumns("master", columnArray);
    },
  },
};
</script>

<style lang="scss">

</style>
